import { render, staticRenderFns } from "./CertificatesInfo.vue?vue&type=template&id=35a58e10&scoped=true"
import script from "./CertificatesInfo.vue?vue&type=script&lang=js"
export * from "./CertificatesInfo.vue?vue&type=script&lang=js"
import style0 from "./CertificatesInfo.vue?vue&type=style&index=0&id=35a58e10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a58e10",
  null
  
)

export default component.exports